export default __webpack_public_path__ + "static/media/Bindings of the Darkwretch.c21f8631.jpg";